import { useState } from "react";
import { Link } from "react-router-dom";

export default function Accordian({ AccordianData, Name }) {
  const [ShowAccordian, setShowAccordian] = useState(false);

  return (
    <div className="card">
      <div className="card-header note note-primary" id="headingOne">
        <button
          type="button"
          onClick={() => setShowAccordian(!ShowAccordian)}
          className="btn btn-link"
          data-toggle="collapse"
          data-target="#collapseOne">
          <i
            className={
              ShowAccordian ? "fas fa-chevron-down" : "fas fa-chevron-right"
            }></i>
          <span className="accordion-title"> {Name} :</span>
        </button>
      </div>
      <div
        id="collapseOne"
        className={ShowAccordian ? "collapse show" : "collapse hide"}
        aria-labelledby="headingOne"
        data-parent="#accordionSE">
        <div className="card-body">
          <div className="show-settings-icons">
            <div className="row">
              {AccordianData?.map((el, i) => (
                <div className="col-3 col-md-1">
                  <div key={i} className="settings-icons text-center">
                    <Link to={el.link}>
                      <img
                        src={el.image}
                        className="img-icon"
                        alt="account_defaults"
                      />
                      <p>{el.name}</p>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <!-- /show-seetings-icons -->*/}
        </div>
      </div>
    </div>
  );
}
